import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "border": "1px solid #ccc",
    "margin-top": "10px"
  },
  class: "edit-wrapper"
};
import { onBeforeUnmount, ref, shallowRef, onMounted, watch } from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import baseURL from "@/config/base-url";
import { localCache } from "@/utils/cache";
import { uploadFile, uploadVideo } from "@/service/modules/upload";
import { addLoading } from "@/utils/element-method";
import "@wangeditor/editor/dist/css/style.css";
export default {
  __name: 'basic-editor',
  props: {
    data: {
      type: String,
      default: ""
    }
  },
  emits: "introChange",
  setup(__props, {
    emit: __emit
  }) {
    const user = localCache.getCache("userInfo");
    // 编辑器实例，必须用 shallowRef，重要！
    const editorRef = shallowRef();
    const emit = __emit;
    const mode = ref("default");
    const props = __props;

    // 内容 HTML
    const valueHtml = ref("");
    const toolbarConfig = {};
    const editorConfig = {
      placeholder: "请输入内容...",
      MENU_CONF: {}
    };
    editorConfig.MENU_CONF["uploadImage"] = {
      async customUpload(file, insertFn) {
        // TS 语法
        // console.log('file', file)
        let res = await uploadFile({
          file
        });
        let url = res.data[0];
        // console.log('url', url)
        insertFn(url, "alt", "href");
        // async customUpload(file, insertFn) {                   // JS 语法
        // file 即选中的文件
        // 自己实现上传，并得到图片 url alt href
        // 最后插入图片
        // insertFn(url, alt, href)
      }
    };
    editorConfig.MENU_CONF["uploadVideo"] = {
      // 自定义插入视频
      async customUpload(file, insertFn) {
        console.log("file", file);
        let instance = addLoading(".edit-wrapper", "视频上传中...");
        try {
          let res = await uploadVideo({
            file
          });
          console.log("res", res);
          let videoUrl = "https://www.yilupei.com:8000" + res.data.video_url;
          insertFn(videoUrl, "poster");
        } catch (e) {
          console.log("e", e);
        } finally {
          instance.close();
        }
        // customInsert(res, insertFn) {
        // res 即服务端的返回结果

        // 从 res 中找到 url poster ，然后插入视频
        // insertFn(url, poster)
      }
    };
    onMounted(() => {
      valueHtml.value = props.data;
    });

    // 组件销毁时，也及时销毁编辑器，重要！
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });

    // 编辑器回调函数
    const handleCreated = editor => {
      console.log("created", editor);
      editorRef.value = editor; // 记录 editor 实例，重要！
    };
    const handleChange = editor => {
      console.log("change:", editor.getHtml());
      emit("introChange", editor.getHtml());
    };
    const handleDestroyed = editor => {
      // console.log('destroyed', editor)
    };
    const handleFocus = editor => {
      // console.log('focus', editor)
    };
    const handleBlur = editor => {
      // console.log('blur', editor)
    };
    const customAlert = (info, type) => {
      // alert(`【自定义提示】${type} - ${info}`)
    };
    const customPaste = (editor, event, callback) => {
      // console.log('ClipboardEvent 粘贴事件对象', event)

      // 自定义插入内容
      // editor.insertText('xxx')

      // 返回值（注意，vue 事件的返回值，不能用 return）
      callback(true); // 返回 false ，阻止默认粘贴行为
      // callback(true) // 返回 true ，继续默认的粘贴行为
    };
    watch(() => props.data, newV => {
      valueHtml.value = newV;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Toolbar), {
        editor: editorRef.value,
        defaultConfig: toolbarConfig,
        mode: mode.value,
        style: {
          "border-bottom": "1px solid #ccc"
        }
      }, null, 8, ["editor", "mode"]), _createVNode(_unref(Editor), {
        defaultConfig: editorConfig,
        mode: mode.value,
        modelValue: valueHtml.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => valueHtml.value = $event),
        style: {
          "width": "900px",
          "height": "430px",
          "overflow-y": "hidden"
        },
        onOnCreated: handleCreated,
        onOnChange: handleChange,
        onOnDestroyed: handleDestroyed,
        onOnFocus: handleFocus,
        onOnBlur: handleBlur,
        onCustomAlert: customAlert,
        onCustomPaste: customPaste
      }, null, 8, ["mode", "modelValue"])]);
    };
  }
};